import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatchingRoutingModule } from './matching-routing.module';
import { MatchingContainerComponent } from './components/matching-container/matching-container.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { SharedModule } from '../shared/shared.module';
import { ResponseSummaryComponent } from './components/response-summary/response-summary.component';
import { GstrResponseComponent } from './components/gstr-response/gstr-response.component';
import { ReconciliationTableComponent } from './components/reconciliation-table/reconciliation-table.component';


@NgModule({
  declarations: [
    MatchingContainerComponent,
    FileUploadComponent,
    ResponseSummaryComponent,
    GstrResponseComponent,
    ReconciliationTableComponent
  ],
  imports: [
    CommonModule,
    MatchingRoutingModule,
    SharedModule
  ],
  exports:[
    GstrResponseComponent,
    FileUploadComponent,
    ResponseSummaryComponent,
    GstrResponseComponent,
    ReconciliationTableComponent
  ]
})
export class MatchingModule { }
